import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  DeleteSupplierMappingMutationRequest,
  DeleteSupplierMappingMutationResponse,
} from "../types/DeleteSupplierMapping"

type DeleteSupplierMappingClient = typeof client<
  DeleteSupplierMappingMutationResponse,
  Error,
  DeleteSupplierMappingMutationRequest
>
type DeleteSupplierMapping = {
  data: DeleteSupplierMappingMutationResponse
  error: Error
  request: DeleteSupplierMappingMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<DeleteSupplierMappingClient>>
  client: {
    parameters: Partial<Parameters<DeleteSupplierMappingClient>[0]>
    return: Awaited<ReturnType<DeleteSupplierMappingClient>>
  }
}
/**
 * @link /v1/client-settings/delete-supplier-mapping
 */
export function useDeleteSupplierMapping(
  options: {
    mutation?: UseMutationOptions<
      DeleteSupplierMapping["response"],
      DeleteSupplierMapping["error"],
      DeleteSupplierMapping["request"]
    >
    client?: DeleteSupplierMapping["client"]["parameters"]
  } = {}
): UseMutationResult<
  DeleteSupplierMapping["response"],
  DeleteSupplierMapping["error"],
  DeleteSupplierMapping["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    DeleteSupplierMapping["response"],
    DeleteSupplierMapping["error"],
    DeleteSupplierMapping["request"]
  >({
    mutationFn: async (data) => {
      const res = await client<
        DeleteSupplierMapping["data"],
        DeleteSupplierMapping["error"],
        DeleteSupplierMapping["request"]
      >({
        method: "delete",
        url: `/v1/client-settings/delete-supplier-mapping`,
        data,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
